module.exports = __webpack_public_path__ + "img/主要功能-小房书@2x.107822cc.png";